import { BLOG_POSTS, BLOG_CONFIG } from '../constants/blog';

const Blog = () => {
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  return (
    <section className="blog-section" id="blog">
      <div className="blog-container">
        <div className="section-header">
          <h2 className="section-title">
            Latest <span className="gradient-text">Insights</span>
          </h2>
          <p className="section-subtitle">
            Technical breakdowns, system design notes, and operator perspectives from active builds.
          </p>
        </div>

        <div className="blog-grid">
          {BLOG_POSTS.map((post) => (
            <article key={post.id} className="blog-card">
              <div className="blog-image-container">
                <img
                  src={post.image}
                  alt={post.title}
                  className="blog-image"
                  loading="lazy"
                />
                <div className="blog-category-badge">{post.category}</div>
              </div>

              <div className="blog-content">
                <div className="blog-meta">
                  <time dateTime={post.date} className="blog-date">
                    {formatDate(post.date)}
                  </time>
                </div>

                <h3 className="blog-title">{post.title}</h3>
                <p className="blog-excerpt">{post.excerpt}</p>

                <div className="blog-tags">
                  {post.tags.map((tag, index) => (
                    <span key={index} className="blog-tag">{tag}</span>
                  ))}
                </div>

                <a
                  href={post.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="blog-read-more"
                >
                  <span>Read Full Article</span>
                  <svg className="arrow-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </div>
            </article>
          ))}
        </div>

        <div className="blog-cta-container">
          <a
            href={BLOG_CONFIG.mainBlogUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="blog-view-all-btn"
          >
            <span>View All Posts</span>
            <svg className="arrow-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
        </div>

        <div className="blog-newsletter">
          <h3 className="blog-newsletter-title">The PHEME Feed</h3>
          <p className="blog-newsletter-text">Market intelligence, signals, and what we're building.</p>
          <form
            className="newsletter-form"
            action="https://quanturama.us11.list-manage.com/subscribe/post?u=bc6e029e0b3678253cc8f7c30&amp;id=ca407f940f&amp;f_id=0053c2e1f0"
            method="post"
            target="_blank"
          >
            <input type="hidden" name="tags" value="434" />
            <input
              type="email"
              name="EMAIL"
              placeholder="Enter your email"
              className="newsletter-input"
              aria-label="Email address"
              required
            />
            <div aria-hidden="true" className="newsletter-hidden-field">
              <input type="text" name="b_bc6e029e0b3678253cc8f7c30_ca407f940f" tabIndex="-1" defaultValue="" />
            </div>
            <button type="submit" className="newsletter-btn">
              Subscribe
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Blog;
